/**
 * @generated SignedSource<<a3838c8e27b6628c4cd871d0fb4f97d5>>
 * @relayHash 5bf7faba01e0332fd774559786d2bf01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d72ab1cf41825166e81a71fa43ec2af7a3a72f0da0a8bd4f08008e35cb41938

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ChatSimulatorPageQuery$variables = {
  helpCenterAri: string;
};
export type ChatSimulatorPageQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly conversationStarters?: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly greetingMessage?: string | null | undefined;
      readonly id?: string;
      readonly name?: string | null | undefined;
    } | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type ChatSimulatorPageQuery = {
  response: ChatSimulatorPageQuery$data;
  variables: ChatSimulatorPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "greetingMessage"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ChatSimulatorPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatSimulatorPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6d72ab1cf41825166e81a71fa43ec2af7a3a72f0da0a8bd4f08008e35cb41938",
    "metadata": {},
    "name": "ChatSimulatorPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bbac70c525bad6e26ad18e970c82fcfe";

export default node;
